import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteWhyChooseUsItem } from "../../api/apiWhyChooseUs";
import parseError from "../../utils/parseError";

export function useDeleteWhyChooseUsItem() {
    const queryClient = useQueryClient();

    const { mutate: deleteItemMutate, isPending } = useMutation({
        mutationFn: deleteWhyChooseUsItem,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["why-choose-us-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete item");
        },
    });

    return { deleteItemMutate, isPending };
}
